import React, { memo } from 'react';
export const VipModuleSection = () => {
  const stages = [{
    title: '1. Activar',
    color: 'text-familia-green',
    dot: 'bg-familia-green',
    border: 'border-familia-green/30',
    desc: 'Presentación, preguntas disparadoras y recuperación de saberes previos.'
  }, {
    title: '2. Aprender',
    color: 'text-familia-electric',
    dot: 'bg-familia-electric',
    border: 'border-familia-electric/30',
    desc: 'Lectura, escritura, matemática, investigación, estadísticas y ciencias.'
  }, {
    title: '3. Evaluar y celebrar',
    color: 'text-familia-violet',
    dot: 'bg-familia-violet',
    border: 'border-familia-violet/30',
    desc: 'Producciones finales, autoevaluación, diplomas y ceremonia.'
  }];
  return <section id="vip" className="bg-familia-section py-10 md:py-16 px-4 md:px-6 border-y border-white/5" data-id="element-268">
      <div className="max-w-5xl mx-auto w-[92%] md:w-full" data-id="element-269">
        <div className="text-center mb-10 md:mb-12" data-id="element-270">
          <div className="inline-block bg-familia-electric/20 text-familia-cyan font-bold text-xs sm:text-sm px-4 py-1.5 rounded-full mb-4 uppercase tracking-wider border border-familia-electric/30" data-id="element-271">
            ⚡ UNA RUTA CLARA PARA NO IMPROVISAR
          </div>
          <h2 className="text-[22px] sm:text-3xl md:text-4xl font-display font-extrabold text-white" data-id="element-272">
            Ruta Didáctica Mundialista 360™
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6 mb-10" data-id="element-273">
          {stages.map((stage, i) => <div key={i} className={`bg-familia-bg border ${stage.border} p-5 md:p-6 rounded-2xl relative overflow-hidden flex flex-col items-center text-center`} data-id="element-274">
              <div className={`w-4 h-4 rounded-full ${stage.dot} mb-3`} data-id="element-275"></div>
              <h3 className={`text-lg md:text-xl font-display font-bold mb-2 ${stage.color}`} data-id="element-276">
                {stage.title}
              </h3>
              <p className="text-white/80 text-[13px] sm:text-sm font-medium" data-id="element-277">
                {stage.desc}
              </p>
            </div>)}
        </div>

        <div className="text-center" data-id="element-278">
          <p className="text-lg md:text-xl font-display font-bold text-familia-gold" data-id="element-279">
            Vos seguís la ruta. Tus estudiantes viven la experiencia.
          </p>
        </div>
      </div>
    </section>;
};